import {
	Container,
	ContainerGutter,
	ContainerPadding,
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { LayoutWrapper } from 'src/feature-app';
import {
	CTAAction,
	CTAThankYou,
	CTAThankYouPage,
	CTAThankYouPageAction,
	LeadsCTAs,
} from '.';

interface FieldProps {
	copyBook?: any;
	copyBookSecond?: any;
	notALayer?: boolean;
	CTAFields?: boolean;
	firstCTA?: CTAThankYou;
	secondCTA?: boolean;
	secondCTACopies?: CTAThankYou;
	CTAAction?: CTAAction;
	ctaFunction?: any;
	ctaUrl?: string;
}

export const ThankYouFields = (props: FieldProps) => {
	const {
		notALayer,
		copyBook,
		CTAFields,
		copyBookSecond,
		firstCTA,
		secondCTA,
		secondCTACopies,
		CTAAction,
		ctaFunction,
		ctaUrl,
	} = props;

	return (
		<LayoutWrapper notALayer={notALayer}>
			<Container
				padding={{
					top: ContainerPadding.dynamic0100,
					bottom: CTAFields
						? ContainerPadding.dynamic0100
						: ContainerPadding.static0,
				}}
				gutter={ContainerGutter.static200}
				wrap={'always'}
			>
				<Text
					appearance={TokenTextAppearance.copy200}
					textAlign={TextAlignment.left}
				>
					{copyBook}
				</Text>
				{copyBookSecond ? (
					<Text
						appearance={TokenTextAppearance.copy200}
						textAlign={TextAlignment.left}
					>
						{copyBookSecond}
					</Text>
				) : null}
			</Container>
			{CTAFields ? (
				<CTAThankYouPage
					firstCTA={firstCTA}
					secondCTA={secondCTA}
					secondCTACopies={secondCTACopies}
				/>
			) : null}
			{CTAAction ? (
				<CTAThankYouPageAction
					ctaInfo={CTAAction}
					ctaFunction={ctaFunction}
				/>
			) : null}
			{ctaUrl ? <LeadsCTAs url={ctaUrl} /> : null}
		</LayoutWrapper>
	);
};
